export const commonHeaders = {
  // accept: '*/*',
  // AK: window.sessionStorage.getItem('SECRET_AK'),
  // User: window.sessionStorage.getItem('SECRET_USERNAME'),
  // ClientTime: new Date().toISOString(),
};
